// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"5ce641f2","365":"5ce641f2","389":"899e6895","684":"5ce641f2","729":"5ce641f2","783":"829ee1bd","823":"f7eb5356","856":"5ce641f2","870":"5ce641f2"}[chunkId] + ".chunk.css";
};